import { render, staticRenderFns } from "./ParamDetails2.vue?vue&type=template&id=54a8096f&scoped=true"
import script from "./ParamDetails2.vue?vue&type=script&lang=js"
export * from "./ParamDetails2.vue?vue&type=script&lang=js"
import style0 from "./ParamDetails2.vue?vue&type=style&index=0&id=54a8096f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a8096f",
  null
  
)

export default component.exports